import type { VideoConsultInvitationType } from '@quromedical/models';
import { AlertButton, type IconName } from 'design-system';
import { VideoConsultApi } from 'integration/aggregate';
import type React from 'react';
import { strings } from 'strings';

interface InviteButtonProps {
  roomId: string;
  patientId: string;
  type: VideoConsultInvitationType;
  icon: IconName;
  buttonText: string;
}

const videoApi = new VideoConsultApi();

export const InviteButton: React.FC<InviteButtonProps> = ({
  roomId,
  patientId,
  type,
  icon,
  buttonText,
}) => {
  const onPress = async () => {
    await videoApi.sendInvite({ roomId, type, subject: patientId });
  };

  return (
    <AlertButton
      variant="flat-alt"
      icon={icon}
      text={buttonText}
      success={{
        title: strings.AlertSuccess,
        body: strings.AlertSendInviteSuccessful,
      }}
      error={{
        title: strings.AlertError,
        body: strings.AlertSendInviteFailed,
      }}
      onPress={onPress}
    />
  );
};
